'use client';

import { Workbook } from 'exceljs';

import { type TableData } from './get-table-data';

const EXCEL_MIME_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
const MIN_COLUMN_WIDTH = 10;
const MAX_COLUMN_WIDTH = 60;
const COLUMN_WIDTH_PADDING = 2;

const getCellLength = (value: Date | null | number | string, valueFormat?: string) => {
  if (value === null) return 0;
  if (value instanceof Date) return valueFormat?.length ?? String(value).length;
  return String(value).length;
};

export const downloadCompanyListingsExcel = async (
  tableData: TableData,
  worksheetName: string,
  fileName: string
) => {
  const workbook = new Workbook();
  const worksheet = workbook.addWorksheet(worksheetName);

  const rows = tableData.rows.map((row) =>
    tableData.columns.map(({ formatValue, formatValueExcel, key }) => {
      const value = row[key];
      if (formatValueExcel) return formatValueExcel(value);
      return formatValue ? formatValue(value) : value;
    })
  );

  worksheet.addTable({
    columns: tableData.columns.map((column) => ({ filterButton: true, name: column.label })),
    headerRow: true,
    name: 'CompanyListings',
    ref: 'A1',
    rows,
    style: { showRowStripes: true },
  });

  for (const [index, column] of tableData.columns.entries()) {
    let longestCellLength = column.label.length;
    for (const row of rows) {
      longestCellLength = Math.max(
        longestCellLength,
        getCellLength(row[index], column.excelValueFormat)
      );
    }

    const worksheetColumn = worksheet.getColumn(index + 1);
    if (column.excelValueFormat) worksheetColumn.numFmt = column.excelValueFormat;
    worksheetColumn.width = Math.min(
      MAX_COLUMN_WIDTH,
      Math.max(MIN_COLUMN_WIDTH, longestCellLength + COLUMN_WIDTH_PADDING)
    );
  }

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: EXCEL_MIME_TYPE });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(url);
};
